import { PatientPreview } from "~/providers/components/patientPreview";

export const LeadPatientPreview = () => <PatientPreview />;
